import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { DataService } from '../../../@core/services/data.service';
import { Subscription } from 'rxjs';
import { HeroBackgroundVideoInterface, SiteNewModel } from '../../../@core/models/site-data.model';
import { MatDialog } from '@angular/material/dialog';
import * as Sentry from "@sentry/browser";
import { AnalyticsService } from '../../../@core/services/analytics.service';


@Component({
  selector: 'app-hero-background-video',
  templateUrl: './hero-background-video.component.html',
  styleUrls: ['./hero-background-video.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialHeroBackgroundVideoComponent implements OnInit, OnDestroy {

  title: string;
  height: number = 700;
  style: string;
  text: string;
  video: string;
  buttonText: string = 'Get Started';
  buttonLink: string;
  buttonsDisplay: number;
  subscription: Subscription;
  data: HeroBackgroundVideoInterface;
  classBuilder: string = '';
  active: boolean = false;
  position: number = 0;
  moduleInfo: string;
  isStock: string = '';
  activatePadding: boolean = false;
  editOn: boolean = false;
  siteId: string = '';
  textAlign: string = '';
  buttonLinkType: string = '';
  allElementAnimation: string;
  textAnimation: string;
  buttonAnimation: string;
  loading: boolean = true;

  constructor(
    private dataService: DataService,
    private dialog: MatDialog,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit() {
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.buttonAnimation = this.data.animation.button != '' ? this.data.animation.button : undefined;

    }
    this.loading = false;
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "HeroImageComponent");
    });
    this.subscription = this.dataService.getSiteId().subscribe(siteId => {
      this.siteId = siteId;
    });
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.height = this.data.height;
    this.title = this.data.title;
    this.text = this.data.text;
    this.video = this.data.video;
    this.buttonText = this.data.buttonText;
    this.buttonLink = this.data.buttonLink;
    this.buttonsDisplay = this.data.buttonsDisplay;
    this.buttonLinkType = this.data.buttonLinkType;
    this.textAlign = this.data.textAlign;
    this.isStock = this.data.isStock;
  }

  clickExternalLink(link) {
    const currentSite = this.dataService.site$.getValue();
    if (currentSite) {
      this.analyticsService.trackConversion(currentSite, 'click');
    }
    // window.open(link, "_blank");
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
